import { isEmpty } from 'lodash';

import { QUESTION_PROMPT_MAX_LENGTH } from 'containers/QuestionnairePage/constants';

const validate = ({ answers = [], prompt, matrix }) => {
  const errors = {};

  if (isEmpty(prompt)) {
    errors.missingPrompt = true;
  }

  const questionTooLong = prompt && prompt.length > QUESTION_PROMPT_MAX_LENGTH;
  if (questionTooLong) {
    errors.questionTooLong = true;
  }

  const hasAnswers = answers.length > 0;

  if (!hasAnswers) {
    errors.missingAnswers = true;
  }

  const labelsEmptyPrompt =
    matrix.columns &&
    matrix.columns.some((column) => isEmpty(column.beforeLabel));

  if (labelsEmptyPrompt) {
    errors.labelsEmptyPrompt = true;
  }

  return errors;
};

export default validate;
